module.exports = __webpack_public_path__ + "media/images/icons/country_flags/et-d27d9d1ac47ed9291a62436693f5f29b.svg";